import React, { useState, useCallback, useMemo, useEffect } from "react";
import { DropDownTree } from "@progress/kendo-react-dropdowns";
import { processTreeData, expandedState } from "./components/tree-data-oprations";
import { useDispatch, useSelector } from "react-redux";
import Skeleton from "@mui/material/Skeleton";
import { getLocationData } from "redux-store/locations/actions";
import SoftBox from "components/SoftBox";
import { findAncestorIds } from "utils/locationTree";

const selectField = "selected";
const expandField = "expanded";
const dataItemKey = "id";
const textField = "text";
const subItemsField = "items";
const fields = {
  selectField,
  expandField,
  dataItemKey,
  subItemsField,
};

const TreeViewLocationFilter = ({dropdownWidth, onChangeHandler, token, selectedLocation=null, locationTree: locationTreeProp}) => {
  const dispatch = useDispatch();
  const { loading, error, data } = useSelector((state) => state.location.getLocationData);

  const [value, setValue] = useState(selectedLocation);
  const [expanded, setExpanded] = useState([]);
  const [filter, setFilter] = useState({
    value: "",
    operator: "contains",
  });

  useEffect(() => {
    if (selectedLocation?.id && value?.id != selectedLocation?.id) {
      setValue(selectedLocation);
    }
  }, [selectedLocation]);

  // console.log("Current value", value);
  // console.log("selectedLocation", selectedLocation);

  useEffect(() => {
    if (!locationTreeProp) {
      dispatch(getLocationData(token));
    }
  }, [dispatch, locationTreeProp]);

  // Pre-expand the chain of ancestors above the currently-selected node so
  // the popup opens with the selection visible instead of forcing the user
  // to drill down through every parent dropdown.
  useEffect(() => {
    const tree = locationTreeProp || data?.locationTree || [];
    if (!tree.length || !selectedLocation?.id) return;
    const ancestors = findAncestorIds(tree, selectedLocation.id);
    if (!ancestors.size) return;
    setExpanded((prev) => {
      const merged = new Set(prev);
      ancestors.forEach((id) => merged.add(id));
      return Array.from(merged);
    });
  }, [locationTreeProp, data, selectedLocation]);

  const onChange = (event) => {
    
    if (onChangeHandler) {
      onChangeHandler(event.value)
    }

    setValue(event.value);
  }
  const onExpandChange = useCallback(
    (event) => setExpanded(expandedState(event.item, dataItemKey, expanded)),
    [expanded]
  );

  const treeData = useMemo(
    () => processTreeData(locationTreeProp || data?.locationTree || [], { expanded, value, filter }, fields),
    [locationTreeProp, data, expanded, value, filter]
  );

  const onFilterChange = (event) => setFilter(event.filter);

  return (
    <SoftBox>
      {loading ? (
        <SoftBox>
          <Skeleton variant="rectangular" height={35} width={200} sx={{ borderRadius: 2 }} />
        </SoftBox>
      ) : (
        <>
          <DropDownTree
            className="custom-dropdown-tree"
            style={{ width: dropdownWidth || '336px' }}
            placeholder="Select Location"
            data={treeData}
            value={value}
            onChange={onChange}
            textField={textField}
            dataItemKey={dataItemKey}
            selectField={selectField}
            expandField={expandField}
            onExpandChange={onExpandChange}
            filterable={true}
            onFilterChange={onFilterChange}
            filter={filter.value}
          />
        </>
      )}
    </SoftBox>
  );
};
export default TreeViewLocationFilter;
